$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    $('.slick-slider').slick('setPosition');
    
    $('.google-map').css('position', '');
    window.setTimeout(function() {
        $('.google-map').css('position', 'relative');
    }, 100);
    
    $(window).trigger('resize');
});

$(window).resize(function() {
    if(window.innerWidth < 992) {
        $('.nav-tabs').each(function() {
            var tabs = $(this);
            
            if(!tabs.hasClass('tabs-dropdown')) {
                tabs.addClass('tabs-dropdown');
                tabs.parents('section').addClass('overflow-visible');
                tabs.find('.nav-item a').removeClass('tabs-last').parent().css('top', 0).css('position', 'relative');
                tabs.find('.nav-item a:not(.active)').last().addClass('tabs-last');

                $.each(tabs.find('.nav-item a:not(.active)').parent().css('position', 'absolute').hide(), function(index, item) {
                    item = $(item);
                    var prev = index - 1;

                    if(index == 0)
                        var offsetTop = parseInt(tabs.find('.nav-item a.active').parent().css('top').replace(/[^-\d\.]/g, '')) + tabs.find('.nav-item a.active').parent().height();
                    else
                        var offsetTop = parseInt($(tabs.find('.nav-item a:not(.active)').parent()[prev]).css('top').replace(/[^-\d\.]/g, '')) + $(tabs.find('.nav-item a:not(.active)').parent()[prev]).height();

                    item.css('top', offsetTop);
                });
                
                tabs.find('.nav-item a:not(.active)').parent().parent().removeClass('open').find('svg').removeClass('d-inline-block');
                tabs.find('.nav-item a.active').find('svg').addClass('d-inline-block');
            } else {
                tabs.find('.nav-item a').removeClass('tabs-last').parent().css('top', 0).css('position', 'relative');
                tabs.find('.nav-item a:not(.active)').last().addClass('tabs-last');

                $.each(tabs.find('.nav-item a:not(.active)').parent().css('position', 'absolute').hide(), function(index, item) {
                    item = $(item);
                    var prev = index - 1;

                    if(index == 0)
                        var offsetTop = parseInt(tabs.find('.nav-item a.active').parent().css('top').replace(/[^-\d\.]/g, '')) + tabs.find('.nav-item a.active').parent().height();
                    else
                        var offsetTop = parseInt($(tabs.find('.nav-item a:not(.active)').parent()[prev]).css('top').replace(/[^-\d\.]/g, '')) + $(tabs.find('.nav-item a:not(.active)').parent()[prev]).height();

                    item.css('top', offsetTop);
                });
                
                tabs.find('.nav-item a:not(.active)').parent().parent().removeClass('open').find('svg').removeClass('d-inline-block');
                tabs.find('.nav-item a.active').find('svg').addClass('d-inline-block');
            }
        });
    } else {
        $('.nav-tabs').each(function() {
            var tabs = $(this);
            
            tabs.removeClass('tabs-dropdown open');
            tabs.parents('section').removeClass('overflow-visible');
            tabs.find('.nav-item a').removeClass('tabs-last').parent().css('top', 0).css('position', 'relative').fadeIn({duration: 200}).find('svg').removeClass('d-inline-block');
        });
    }
});

$('.nav-tabs').on('click', '.nav-item a.active', function() {
    if($(this).closest('.tabs-dropdown').hasClass('open'))
        $(this).closest('.tabs-dropdown').find('.nav-item a:not(.active)').parent().fadeOut({duration: 200}).parent().removeClass('open');
    else
        $(this).closest('.tabs-dropdown').find('.nav-item a:not(.active)').parent().fadeIn({duration: 200}).parent().addClass('open');
});

$(document).click(function(e) {
    if (!$('.tabs-dropdown').is(e.target) && $('.tabs-dropdown').has(e.target).length === 0) {
        $('.tabs-dropdown').find('.nav-item a:not(.active)').parent().fadeOut({duration: 200}).parent().removeClass('open');
    }
});


// WEBPACK FOOTER //
// ./js/contentelements/tabs.js